/**
 * Created with IntelliJ IDEA.
 * User: omerh
 * Date: 5/7/13
 * Time: 2:14 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var Marionette = require("marionette");
    var Template = require("connection-templates/chatInvitation.tmpl");
    var _ = require("underscore");

    var ChatInvitationItemView = Marionette.ItemView.extend({
        template: Template,
        tagName: "div",
        events: {
            "click" : "onclick"
        },
        initialize: function(options){
           this.onclick = options.onclick;
        }
    });
    return ChatInvitationItemView;
});
